export const SEARCH_DELAY = 500;

export const DURATION_OPTIONS = [
  { value: '0 - 59', label: '1 min >' },
  { value: '60 - 299', label: '1 - 5 min' },
  { value: '300', label: '5 min <' },
];
export const CONVERSATION_TYPE_OPTIONS = [
  { value: 'TextConversation', label: 'SMS' },
  { value: 'AnalyticsCall', label: 'AI Call' },
  { value: 'AgentCall', label: 'Agent Call' },
  { value: 'ChatConversation', label: 'Chatbot' },
  { value: 'EmailConversation', label: 'E-mail' },
];

export const STATUS_OPTIONS = [
  { value: 'live', label: 'Live' },
  { value: 'resolved', label: 'Resolved' },
];

export const AGENT_OPTIONS = [
  { value: 'ai', label: 'AI' },
  { value: 'human', label: 'Human' },
];

export const LANGUAGE_OPTIONS = [
  { value: 'en-us', label: 'English' },
  { value: 'es-mx', label: 'Spanish' },
];
